import React from 'react';
import { Home as HomeIcon, Info as InfoIcon, Login as LoginIcon, SupervisorAccount as AdminIcon, Help as HelpIcon, Place as PlaceIcon, Spa as SpaIcon, TableView as TableViewIcon, Map as MapIcon, Dashboard, Storage, Grain, Grass, NaturePeople, Public, Terrain, FileDownload, Thunderstorm, Sync, } from '@mui/icons-material';
const iconMap = {
    HomeIcon,
    InfoIcon,
    LoginIcon,
    AdminIcon,
    HelpIcon,
    PlaceIcon,
    SpaIcon,
    TableViewIcon,
    MapIcon,
    Dashboard,
    Storage,
    Grain,
    Grass,
    NaturePeople,
    Public,
    Terrain,
    FileDownload,
    Thunderstorm,
    Sync,
};
const IconComponent = ({ iconName }) => {
    const Icon = iconMap[iconName];
    return Icon ? React.createElement(Icon, null) : null;
};
export default IconComponent;
